import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * Lab-test unit-of-measurement list. Backed by the reference-list
 * endpoint `GET /api/v1/dt/referenceList/getByName?name=LAB_TEST_UOM`,
 * which returns `[{ label, value }]` where `label` is the human unit
 * ("mg/dL") and `value` is the REFLD code. Only the label is surfaced
 * to the picker + persisted on entries — matches every other unit
 * field on the wire, which is a plain string.
 *
 * Module-level cache: first call fetches; every subsequent call
 * short-circuits to the cached array. Callers dropping into either the
 * Digitise-manually modal or the Correction dialog therefore share a
 * single load. Failures degrade to an empty list so the picker just
 * shows "No units available" instead of crashing.
 */

let CACHE = null;
let INFLIGHT = null;

export const getCachedUnitOptions = () => CACHE;

export const fetchUnitOptions = () => {
  if (CACHE) return Promise.resolve(CACHE);
  if (INFLIGHT) return INFLIGHT;
  INFLIGHT = new Promise((resolve) => {
    const svc = new APIService();
    const url = APIConfig.referenceList.getByName.format("LAB_TEST_UOM");
    svc.get(
      url,
      (res) => {
        const rows = Array.isArray(res) ? res : (res && Array.isArray(res.data) ? res.data : []);
        // Preserve upstream order — the reference list is curated on
        // the backend; the picker should render in the same sequence.
        // Dedup on the label string (Set keeps first-seen order) so a
        // duplicate REFLD row doesn't produce a repeated option.
        const labels = Array.from(new Set(
          rows.map((r) => (r && (r.label || "")).toString().trim()).filter(Boolean),
        ));
        CACHE = labels;
        INFLIGHT = null;
        resolve(labels);
      },
      () => {
        CACHE = [];
        INFLIGHT = null;
        resolve([]);
      },
    );
  });
  return INFLIGHT;
};
